export const STAGES_CONFIG = {
    'TWG Program Enrolled': { color: '#0464AD', icon: '📝' }, 
    'Documentation': { color: '#00B7CF', icon: '📂' },
    'I20/CAS/CoE': { color: '#F15E3B', icon: '🎓' },
    'Visa': { color: '#FCB017', icon: '🛂' },
    'Progressed Overseas': { color: '#0091D0', icon: '✈️' },
    'Dropped': { color: '#606161', icon: '❌' },
};

export const STAGES = Object.keys(STAGES_CONFIG);

export const MONTHS = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

export const APPLICATION_STATUSES = [
  'Draft',                                    // New Stage
  'App Submitted',                            // Was: Received
  'More Info Requested',                      // No change
  'Submitted to University',                  // No change
  'App Accepted',                             // Was: Successful
  'Offer Shared with Agent',                  // Was: Submitted to Agent
  'Offer Shared with Student',                // Was: Submitted to Student
  'Offer Signed - Pending Payment',           // Was: Acceptance Received - Pending Payment
  'Offer Signed - Payment Completed',         // Was: Acceptance Received - Payment Received
  'Enrolled in TWG Program',                  // Was: Enrolled in Hybrid
  'Rejected',
  'Withdrawn'
];

// Updated to only show the specific requested years
export const YEARS = [2022, 2023, 2024, 2025, 2026, 2027, 2028];